import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_CAPITAL_PROVINCE } from "../Schema/CapitalProvince";

export const useGetCapitalProvince = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const { refetch } = useQuery(GET_CAPITAL_PROVINCE, {
    onCompleted: ({ getCapitalProvince }) => {
      setTableData(getCapitalProvince);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return {
    refetch,
    loading,
    tableData,
    setLoading,
  };
};
